export const getGroupLabel = (group: string) => {
    switch (group) {
        case 'full team member':
            return 'Full Access';
        case 'limited team member':
            return 'Limited Access';
        case 'no access team member':
            return 'No Login';
        default:
            return 'Unknown';
    }
};

export const toUSD = (amount: number | string | null | undefined) => {
    try {
        // Convert to number if it's a string or handle null/undefined
        const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
        
        // If still not a valid number, default to 0
        if (numAmount === null || numAmount === undefined || isNaN(numAmount)) {
            return '$0.00';
        }
        
        return numAmount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    } catch (error) {
        return '$0.00';
    }
};

/**
 * Strip all non-alphanumeric characters from a string and replace spaces with underscores
 * @param file - File object or filename string
 * @returns string - sanitized filename
 */
export const normalizeFileName = (file: File | string): string => {
    const filename = typeof file === 'string' ? file : file.name;
    const filenameParts = filename.split('.');
    const ext = filenameParts[filenameParts.length - 1];
    const name = filenameParts[0]
        .replace(/\s+/g, '_')      // Replace spaces with underscores
        .replace(/[^\w]/g, '');    // Remove all non-alphanumeric characters (except underscore)
    const fileName = `${name}.${ext}`;
    return fileName;
};

export const getBadgeLabel = (statusValue: string, statusLabel: string) => {
    if (['ap_review', 'for_dof_approval'].includes(statusValue)) {
        return 'In Review';
    }
    if (statusValue === 'needs_info') {
        return 'Needs Info';
    }
    if (statusValue === 'in_mip') {
        return 'Approved';
    }
    return statusLabel;
};

/**
 * Get the appropriate CSS badge class based on the badge display label
 * This ensures consistent styling with the StatusLegendModal
 * @param badgeLabel - The display label for the badge
 * @param statusValue - The original status value as fallback
 * @returns CSS class name for the badge
 */
export const getBadgeClass = (badgeLabel: string, statusValue: string) => {
    switch (badgeLabel) {
        case 'Draft':
            return 'badge-draft';
        case 'Submitted':
            return 'badge-submitted';
        case 'In Review':
            return 'badge-in_review';
        case 'Needs Info':
            return 'badge-needs_info';
        case 'Resubmitted':
            return 'badge-resubmitted';
        case 'Approved':
            return 'badge-approved';
        case 'Paid':
            return 'badge-paid';
        case 'Rejected':
            return 'badge-rejected';
        default:
            // Fallback to original status value pattern for any unmapped labels
            return `badge-${statusValue}`;
    }
};
